// StyledRadioLabel.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledRadioLabelBase = styled.label`
  outline: none;
  font-size: ${({ styling }) => `${styling.radioLabelFontSize}px`};
  font-weight: ${({ styling }) => styling.radioLabelFontWeight};
  font-family: ${({ styling }) => styling.radioLabelFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  color: ${({ styling }) => styling.radioLabelColor};
`;

const StyledRadioLabel = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledRadioLabelBase {...props} placeholder={placeholderText} />;
};



export default StyledRadioLabel;
